import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "mb-10" }, [
  /*#__PURE__*/_createVNode("h1", { class: "anchor fw-bolder mb-5" }, [
    /*#__PURE__*/_createVNode("a", { href: "#progress" }),
    /*#__PURE__*/_createTextVNode(" Progress ")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "py-5" }, " Progress is used to show the progress of current operation, and inform the user the current status. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EUILinearProgressBar = _resolveComponent("EUILinearProgressBar")
  const _component_EUIInternalPercentage = _resolveComponent("EUIInternalPercentage")
  const _component_EUICustomColor = _resolveComponent("EUICustomColor")
  const _component_EUICircularProgressBar = _resolveComponent("EUICircularProgressBar")
  const _component_EUIDashboardProgressBar = _resolveComponent("EUIDashboardProgressBar")
  const _component_EUICustomizedContent = _resolveComponent("EUICustomizedContent")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_EUILinearProgressBar),
    _createVNode(_component_EUIInternalPercentage),
    _createVNode(_component_EUICustomColor),
    _createVNode(_component_EUICircularProgressBar),
    _createVNode(_component_EUIDashboardProgressBar),
    _createVNode(_component_EUICustomizedContent)
  ], 64))
}